import React, { useState, useMemo } from 'react'
import { Button } from '@mondra/ui-components'
import classNames from 'classnames'
import { exportGraphqlXlsx, IExportGraphqlPayload } from '../../shared/exportGraphqlApi'
import { useAppDispatch } from '../../hooks/redux'
import { showCorrelationIdError } from '../../redux/correlationIdSlice'

interface IExportGraphqlButtonProps {
  className?: string
  payload: IExportGraphqlPayload
}

export function ExportGraphqlButton({ className, payload }: IExportGraphqlButtonProps) {
  const [isLoading, setIsLoading] = useState(false)
  const dispatch = useAppDispatch()
  const handleExport = async () => {
    setIsLoading(true)

    try {
      const { data } = await exportGraphqlXlsx(payload)

      setIsLoading(false)

      if (data?.fileUrl) {
        window.open(data.fileUrl, '_blank', 'noopener,noreferrer')
      }
    } catch (error: any) {
      setIsLoading(false)
      if (error.showCorrelationId) {
        dispatch(showCorrelationIdError(error.CorrelationId))
      }
    }
  }

  const exportButtonProps = useMemo(
    () =>
      isLoading
        ? {
            className: classNames('pointer-events-none', className),
            iconClass: 'animate-spin',
            iconType: 'spinnerThird',
          }
        : { iconType: 'fileExport' },
    [isLoading, className]
  )

  return (
    <Button
      onClick={handleExport}
      variant="secondary"
      className={className}
      disabled={isLoading}
      {...exportButtonProps}
    >
      Export
    </Button>
  )
}
